import UserLogin from '../components/public/UserLogin';
export default {
    Login: {
        component: UserLogin,
        path: '/login'
    },
};


// WEBPACK FOOTER //
// ./src/routes/sessionRoutes.js